import Search from './Search';
import {React, useEffect, useState } from "react";
import createClient from '../Client';
import { Link } from 'react-router-dom';
import manual from '../images/icons8-user-manual-100.png';
import Loader from "../components/Loader";

// hero section of home page
const Hero = ({ setHeroDataLoaded })  => {

    const[bannerData, setBannerData] = useState([]);
    const [modal, setModal] = useState(false);
    const [videoLoading, setVideoLoading] = useState(true);
  
    const openModal = () => {
      setModal(!modal);
    };
  
    const closeVideo = () => {
      setModal(false);
    };
    const spinner = () => {
      setVideoLoading(!videoLoading);
    };

    useEffect(() => {
      createClient.fetch(`*[_type == 'home']{
        ...,
        "bgImage":hm_banner_bg_image.asset->url,
        hm_banner_yt_link,
        hm_update_text,
        hm_update_label,
        hm_update_link,
        "heroTitle":hm_banner_title,
        hm_update_check,
        "heroImage":hm_banner_image.asset->url,
        "heroDes":hm_banner_text,
        "buttomlink":hm_banner_button.hm_banner_button_link,
        "buttomText":hm_banner_button.hm_banner_button_text,
        "downloadButton": hm_app_download_link[]{
          ...,
          "buttonImage":hm_play_store_img.asset->url
          }
        }`).then((data) => {
            setBannerData(data[0]);
            setHeroDataLoaded(true);
        })
      .catch(console.error);
  },[])

  if (!bannerData) {
    return <Loader />; // Show loader until Hero data is fetched
}

    return(
        <>
       {bannerData? (
        <section className="hero hero-lead pb-50" id="hero">
            <div className="hero-cotainer">
                <div className="hero-bg"> 
                    <img src={bannerData.bgImage ? bannerData.bgImage : ''}/>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-6"> 
                            <div className="hero-content">
                                <Search bannerData={bannerData}></Search>
                                <h1 className="hero-headline">{bannerData.heroTitle}</h1>
                                <p className="hero-bio">{bannerData.heroDes}</p>
                                <div className="hero-action">
                                  {/* {bannerData.buttomlink ? 
                                   <Link className='btn btn--primary' target="_blank" to={`${bannerData.hm_ud_link}`}>
                                   <svg xmlns="http://www.w3.org/2000/svg" width="28.114" height="31.16" viewBox="0 0 28.114 31.16">
                                       <path id="app" d="M37.384,12.606,16.12.451A3.425,3.425,0,0,0,11,3.425V27.734a3.425,3.425,0,0,0,5.125,2.974L37.383,18.554a3.425,3.425,0,0,0,0-5.948ZM28.17,9.732,25.25,13.8,18.267,4.071ZM14.286,29.071a1.336,1.336,0,0,1-.542-.17,1.352,1.352,0,0,1-.671-1.166V3.425a1.342,1.342,0,0,1,1.212-1.339L23.971,15.58Zm3.98-1.982,6.983-9.728,2.92,4.067ZM36.353,16.75l-6.37,3.641L26.529,15.58l3.454-4.811,6.37,3.641a1.348,1.348,0,0,1,0,2.34Z" transform="translate(-10.995)"></path>
                                   </svg>
                                   <span>{bannerData.hm_ud_label? bannerData.hm_ud_label : "Download"}</span></Link>
                                   : null
                                }
                              
                                    {bannerData.hm_banner_yt_link ? 
                                      <a onClick={openModal}  className="btn-video popup-video"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="29" viewBox="0 0 22 29">
                                        <path id="Polygon_3" data-name="Polygon 3" d="M12,3.8A3,3,0,0,1,17,3.8l8.93,13.549A3,3,0,0,1,23.43,22H5.57a3,3,0,0,1-2.5-4.651Z" transform="translate(24) rotate(90)"></path>
                                    </svg></a>
                                    : null
                                    } */}
                                    {
                                      bannerData.downloadButton
                                       && bannerData.downloadButton.map((downloadItem, index) => (
                                        downloadItem.hm_play_store_link ? (<Link key={index} to={`${downloadItem.hm_play_store_link}`} target="_blank">
                                          <img src={downloadItem.buttonImage} alt={downloadItem.hm_play_store_text}/>
                                        </Link>):(
                                         
                                          <img src={downloadItem.buttonImage} alt={downloadItem.hm_play_store_text}/>
                                        
                                        )
                                          
                                       ))
                                    }
                                </div>
                                {(bannerData.hm_ud_link || bannerData.hm_banner_yt_link) && (
                                <div className="hero-action mt-20">
                                  {bannerData.hm_ud_link ? 
                                   <Link className='btn btn--primary' target="_blank" to={`${bannerData.hm_ud_link}`}>
                                   {/* <svg xmlns="http://www.w3.org/2000/svg" width="28.114" height="31.16" viewBox="0 0 28.114 31.16">
                                       <path id="app" d="M37.384,12.606,16.12.451A3.425,3.425,0,0,0,11,3.425V27.734a3.425,3.425,0,0,0,5.125,2.974L37.383,18.554a3.425,3.425,0,0,0,0-5.948ZM28.17,9.732,25.25,13.8,18.267,4.071ZM14.286,29.071a1.336,1.336,0,0,1-.542-.17,1.352,1.352,0,0,1-.671-1.166V3.425a1.342,1.342,0,0,1,1.212-1.339L23.971,15.58Zm3.98-1.982,6.983-9.728,2.92,4.067ZM36.353,16.75l-6.37,3.641L26.529,15.58l3.454-4.811,6.37,3.641a1.348,1.348,0,0,1,0,2.34Z" transform="translate(-10.995)"></path>
                                   </svg> */}
                                   <img className="userManual" src={manual} alt="User Manual" />
                                   <span>{bannerData.hm_ud_label? bannerData.hm_ud_label : "Download"}</span></Link>
                                   : null
                                  }
                              
                                    {bannerData.hm_banner_yt_link ? 
                                      <a onClick={openModal}  className="btn-video popup-video"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="29" viewBox="0 0 22 29">
                                        <path id="Polygon_3" data-name="Polygon 3" d="M12,3.8A3,3,0,0,1,17,3.8l8.93,13.549A3,3,0,0,1,23.43,22H5.57a3,3,0,0,1-2.5-4.651Z" transform="translate(24) rotate(90)"></path>
                                    </svg></a>
                                    : null
                                    }
                                </div>
                                )}
                              </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="hero-image"><img className="img-fluid" src={bannerData.heroImage} /></div>
                        </div>
                    </div>


                    {modal ? (
          <div className="modal__bg">
            <div className="overlay" >
            <div className="modal__align">
              <div className="modal__content" modal={modal}>
                
                <div className="modal__video-align">
                <div
                  className="modal__close"
                  arial-label="Close modal"
                  onClick={closeVideo} 
                >X</div>
                  {videoLoading ? (
                    <div className="modal__spinner">
                      
                    </div>
                  ) : null}
                  {/* <iframe
                    className="modal__video-style"
                    onLoad={spinner}
                    loading="lazy"
                    width="800"
                    height="500"
                    src={bannerData.hm_banner_yt_link}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe> */}
                   <video
                      className="modal__video-style"
                      onLoadedData={spinner} // Use onLoadedData
                      controls // Add controls for play/pause, etc.a
                      width="800"
                      height="500"
                      autoPlay
                      src={bannerData.hm_banner_yt_link} // Use the .mp4 URL
                      loading="lazy"
                    >
                    </video>
                </div>
              </div>
            </div>
            </div>
            
          </div>
        ) : null}
                
                </div>
            
            </div>
        
            <div className="skew-divider"></div>
        </section>
          ) : null}
        </>
    );
}

export default Hero;